import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import ConfirmationModal from "../../Controls/ConfirmationModal";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";
import { useDispatch } from "react-redux";
import { addLoginResponse } from "../../../features/login/loginSlice";

const RunRouteSuggestion = (props) => {
    const dispatch = useDispatch();
    const { AffiliateData,GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showRouteSuggestionAlert, setRouteSuggestionAlert] = useState(false);
    const [RouteSuggestionAlertObj, setRouteSuggestionAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',btnOkText: 'Yes'});
    const [confirmationModalObj1, setConfirmationModalObj1] = useState({show: false, title:'Route Suggestion', body:'please mark routes selected for the day other than selected trip route to do route suggestion', btnCanceText: 'No',btnOkText: 'OK'});

    useEffect(() => {
        async function fetchData(){
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: 'No request selected to perform Action.' , displayFooter: true});
            setRouteSuggestionAlert(true);
        }
        else {
            //let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
            let result = false;
            if(result){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes'}));
            }else{
                await RouteSuggestionActions();
            }
        }

    }
            fetchData();
    }, []);

    const RouteSuggestionActions = async() =>{
        try{

        
            const selectedGridData = props.GridRowData
            const affID = selectedGridData[0].iSRATSPID;
           

            if (props.showRouteSuggestionActionCreate) {
                BuildRouteSuggestion(selectedGridData, affID);
            }
        }
        catch(err){console.log(err);}
    }
    

    const BuildRouteSuggestion = async (selectedGridData, iAffiliateID) => {
        props.disbaleButton(true);
        let ids = null;
        let selectedRoutes=null;
        let callBackURL = "";
        let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === iAffiliateID);
        ids = GetServiceNScheduleIDsForWillMRM_New(selectedGridData, true);
        let routedtripRoute=ids?.[2]?.[0]?.ManifestNumber?.toString().slice(8) ?? "";
        if(routedtripRoute!='' && filteredData.length > 0) {
            let iTransTypeValue = '0';
            if (filteredData[0].iTransType !== undefined && filteredData[0].iTransType !== null) {
              iTransTypeValue = String(filteredData[0].iTransType);
            }
           selectedRoutes = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllTodaysRoutes?selected_date=" + selectedGridData[0].PickupDateTime + "&affiliate_id=" + iAffiliateID + "&iTransType=" + iTransTypeValue + "&bMainTables=true" , "get", {"Content-Type": "application/json"}, null, null);

           if(selectedRoutes?.data?.filter(item=> item.vVirtualRoute===routedtripRoute && item.SelectedForTheDay===1).length===1 && selectedRoutes?.data?.filter(item=> item.vVirtualRoute!==routedtripRoute && item.SelectedForTheDay===1).length===0){
                setConfirmationModalObj1((prevState) => ({...prevState, show:true}));
                return;
           }

        }
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }
        let Data = {
            "Trips": JSON.stringify(ids[2]),
            "iAffiliateID" : iAffiliateID,
            "dtPickupDateTime" : pickupDateTime,
            "iCreatedByAppId":26,
            "iCreatedByUID":loginData.iUserID,
            "call_back_url":callBackURL,
            "UpdateReason": '13'
        }
        setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route Suggestion In Progress', alertMsg: 'Please Wait...' , displayFooter: false});
        setRouteSuggestionAlert(true);
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BuildManifestDispatch", "post", { "Content-Type": "application/json" }, Data, null);
        let result = response.data;
        if (result.run_id > 0) {
            const newLoginData = {
                ...loginData, // Spread the existing properties of loginData
                BuildManifestDispatchID:true, // Update the specific field
              };
            dispatch(addLoginResponse(newLoginData));
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route Suggestion Started', alertMsg: 'Route Suggestion is being performed...' , displayFooter: false});
            setRouteSuggestionAlert(true);
            props.disbaleButton(true);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: result.error_message , displayFooter: true});
            setRouteSuggestionAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
        else {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: 'Something went wrong !!!' , displayFooter: true});
            setRouteSuggestionAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();

        }
    }

    function GetServiceNScheduleIDsForWillMRM_New(array, bwillCallReqs) {
        var bwillCallReqsLocal = false;
        try {
            bwillCallReqsLocal = bwillCallReqs;
        } catch (Error) { }
        var result = Array();
        var service_ids = "";
        var schedule_ids = "";
        var trips = [];
        //var smaIDs = "";
        for (var i = 0; i < array.length; i++) {
                if ((array[i].bIsSchedule == "1")) {
                    schedule_ids += array[i].iScheduleID + ",";
                    trips.push({
                        "iScheduleID": array[i].iScheduleID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"],
                        "ManifestNumber":array[i]["vManifestNumber"]
                    });
                }
                else {
                    service_ids += array[i].ServiceID + ",";
                    trips.push({
                        "iServiceID": array[i].ServiceID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"],
                        "ManifestNumber":array[i]["vManifestNumber"]

                    });
                }
        }
        try {
            if ((service_ids != "") && (service_ids[service_ids.length - 1] == ','))
                service_ids = service_ids.substring(0, (service_ids.length - 1));
    
            if ((schedule_ids != "") && (schedule_ids[schedule_ids.length - 1] == ','))
                schedule_ids = schedule_ids.substring(0, (schedule_ids.length - 1));
        } catch (Error) { }
        result.push(service_ids);
        result.push(schedule_ids);
        result.push(trips);
        return result;
    }

    const handleRouteAlertClose = () => {
        setRouteSuggestionAlert(false);
        UnMountUnRouteComponent();
    }

    const UnMountUnRouteComponent = () => {
        if (props.showRouteActionCreate) {
            props.setUnRouteActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () =>{
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        RouteSuggestionActions();
    }
    const handleConfirmationModalOk1 = () =>{
        setConfirmationModalObj1((prevState) => ({...prevState, show:false}));
        props.setGridRefreshPaused(false);
        props.setRouteSuggestionActionCreate(false);
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setRouteSuggestionActionCreate(false);
        props.setGridRefreshPaused(false);
    }
    const handleConfirmationModalCancel1 = () =>{
        setConfirmationModalObj1((prevState) => ({...prevState, show:false}));
        props.setGridRefreshPaused(false);
        props.setRouteSuggestionActionCreate(false);

    }
    
    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setRouteSuggestionActionCreate(false);
        props.setGridRefreshPaused(false);
    }
    const handleConfirmationModalClose1 = () => {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
        props.setGridRefreshPaused(false);
        props.setRouteSuggestionActionCreate(false);

    }

    return (
        <>
            {showRouteSuggestionAlert && <Modal centered keyboard={false} show={showRouteSuggestionAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{RouteSuggestionAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{RouteSuggestionAlertObj.alertMsg}</b></Modal.Body>
                {RouteSuggestionAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
            btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
            <ConfirmationModal show={confirmationModalObj1.show} Title={confirmationModalObj1.title} Body={confirmationModalObj1.body}
            onOk={handleConfirmationModalOk1} onCancel={handleConfirmationModalCancel1} onClose={handleConfirmationModalClose1} btnCanceText={confirmationModalObj1.btnCanceText}
            btnOkText={confirmationModalObj1.btnOkText} ShowCancelButton="false" />
        </>
    );

};

export default RunRouteSuggestion;